<template>
  <div class="board__realities pt-1">
    <div class="board__realty-wrapper">
      <v-icon class="grey lighten-3 grey--text text--lighten-1" left>
        mdi-home
      </v-icon>
      <div class="board__realty">
        <h5 class="grey--text">
          {{ $t('board.realties') }}
        </h5>
        <div
          v-for="(realty, index) in realties"
          :key="realty.code"
        >
          <v-divider v-if="index !== 0" class="my-3" />

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="d-block mb-2 body-2 text-truncate ellipsis">
                {{ realty.address }}
              </span>
            </template>
            {{ realty.address }}
          </v-tooltip>

          <v-row no-gutters>
            <v-col>
              <h5 class="grey--text">
                {{$t('realty.label.privateArea')}}
              </h5>
              <p class="body-2 mb-0">
                {{realty.private_area_meters}}
                {{$t('appointment.label.squareMetersSymbol')}}
              </p>
            </v-col>
            <v-col>
              <h5 class="grey--text">
                {{$t('realty.label.totalArea')}}
              </h5>
              <p class="mb-0 body-2">
                {{realty.square_meters}}
                {{$t('appointment.label.squareMetersSymbol')}}
              </p>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardRealtiesList',

  props: {
    realties: {
      type: Array
    }
  }
}
</script>

<style scoped>
.ellipsis {
  max-width: 100%;
}
</style>
